import makeActionCreator from './makeActionCreator';
import {
  FETCH_HEROES,
  FETCH_HEROES_DONE,
  FETCH_HEROES_ERROR,
  FETCH_HEROES_LOADING,
  FETCH_HEROES_SUCCESS,
  FETCH_POPINS,
  FETCH_POPINS_DONE,
  FETCH_POPINS_ERROR,
  FETCH_POPINS_LOADING,
  FETCH_POPINS_SUCCESS,
  FETCH_TENANT_STATS,
  FETCH_TENANT_STATS_DONE,
  FETCH_TENANT_STATS_ERROR,
  FETCH_TENANT_STATS_LOADING,
  FETCH_TENANT_STATS_SUCCESS,
  FETCH_USERS,
  FETCH_USERS_DONE,
  FETCH_USERS_ERROR,
  FETCH_USERS_LOADING,
  FETCH_USERS_SUCCESS,
  FETCH_ACTIVITIES_BY_USE_CASE,
  FETCH_ACTIVITIES_BY_USE_CASE_DONE,
  FETCH_ACTIVITIES_BY_USE_CASE_ERROR,
  FETCH_ACTIVITIES_BY_USE_CASE_LOADING,
  FETCH_ACTIVITIES_BY_USE_CASE_SUCCESS
} from './actionTypes';

// FETCH STATS OVERVIEW

export const fetchTenantStats = makeActionCreator(FETCH_TENANT_STATS, 'tenantId', 'numWeeks');
export const fetchTenantStatsLoading = makeActionCreator(FETCH_TENANT_STATS_LOADING);
export const fetchTenantStatsSuccess = makeActionCreator(FETCH_TENANT_STATS_SUCCESS, 'allStats');
export const fetchTenantStatsError = makeActionCreator(FETCH_TENANT_STATS_ERROR, 'error');
export const fetchTenantStatsDone = makeActionCreator(FETCH_TENANT_STATS_DONE);

// FETCH USERS

export const fetchUsers = makeActionCreator(FETCH_USERS, 'tenantId', 'numWeeks');
export const fetchUsersLoading = makeActionCreator(FETCH_USERS_LOADING);
export const fetchUsersSuccess = makeActionCreator(FETCH_USERS_SUCCESS, 'usersData');
export const fetchUsersError = makeActionCreator(FETCH_USERS_ERROR, 'error');
export const fetchUsersDone = makeActionCreator(FETCH_USERS_DONE);

// FETCH HEROES

export const fetchHeroes = makeActionCreator(FETCH_HEROES, 'tenantId', 'numWeeks');
export const fetchHeroesLoading = makeActionCreator(FETCH_HEROES_LOADING);
export const fetchHeroesSuccess = makeActionCreator(FETCH_HEROES_SUCCESS, 'heroesData');
export const fetchHeroesError = makeActionCreator(FETCH_HEROES_ERROR, 'error');
export const fetchHeroesDone = makeActionCreator(FETCH_HEROES_DONE);

// FETCH POPINS
export const fetchPopins = makeActionCreator(FETCH_POPINS, 'tenantId', 'numWeeks');
export const fetchPopinsLoading = makeActionCreator(FETCH_POPINS_LOADING);
export const fetchPopinsSuccess = makeActionCreator(FETCH_POPINS_SUCCESS, 'popinsData');
export const fetchPopinsError = makeActionCreator(FETCH_POPINS_ERROR, 'error');
export const fetchPopinsDone = makeActionCreator(FETCH_POPINS_DONE);

// FETCH ACTIVITIES BY USE CASE

export const fetchActivitiesByUseCase = makeActionCreator(FETCH_ACTIVITIES_BY_USE_CASE, 'tenantId',
  'numWeeks');
export const fetchActivitiesByUseCaseLoading = makeActionCreator(
  FETCH_ACTIVITIES_BY_USE_CASE_LOADING);
export const fetchActivitiesByUseCaseSuccess = makeActionCreator(
  FETCH_ACTIVITIES_BY_USE_CASE_SUCCESS, 'activities');
export const fetchActivitiesByUseCaseError = makeActionCreator(FETCH_ACTIVITIES_BY_USE_CASE_ERROR,
  'error');
export const fetchActivitiesByUseCaseDone = makeActionCreator(FETCH_ACTIVITIES_BY_USE_CASE_DONE);
